import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { SHELL_CATALOGS } from "./model/account-copy.ts";

// The platform's chrome. It lends the "app" layout every platform screen
// renders inside, and the catch-all screen; the sidebar is built from what
// installed modules declare.
export const platformShellBrowserModule: BrowserModule = defineBrowserModule("platform-shell")
  .withLayouts({
    app: { load: () => import("./ui/sections/app-layout.tsx") },
    auth: { load: () => import("./ui/sections/auth-layout.tsx") },
  })
  .withScreens({
    notFound: {
      path: "*",
      title: phrase(SHELL_CATALOGS, "notFoundPageTitle"),
      layout: "app",
      load: () => import("./ui/sections/not-found-screen.tsx"),
    },
  });
